module.exports = __webpack_public_path__ + "static/carousel-6-e007a1d4311095830f94af9700b63998.png";